import { DataSourceEnum } from '../../../workflow/types/workflow.types';

export enum DashboardDateRangeEnum {
  DAY = 'day',
  MONTH = 'month',
  QUARTER = 'quarter',
}

export interface VisaApplicationReportQueryParams {
  dateRange: DashboardDateRangeEnum;
  dataSource?: DataSourceEnum | string;
  workflowIds?: string[];
}

export interface VisaApplicationReportItem {
  date: string;
  successCount: number;
  failedCount: number;
  incompleteCount: number;
  totalApplications: number;
  firstTimeSuccessRate: number;
  workflowId?: string;
  workflowNames?: string[];
}

export interface VisaApplicationReportResponse {
  success: boolean;
  data: VisaApplicationReportItem[];
}
